// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer__item":"Footer_footer__item__q0XnZ","footer__title":"Footer_footer__title__AKgXd","footer__description":"Footer_footer__description__a9kjI"};